<template>
    <div v-if="isActive" class="select-user-overlay">
        <div class="container-select-user">
            <h4>{{ $t('dash.select-users.title') }}</h4>
            <p>{{ params.subTitle || 'Undefined'}}</p>
            <div class="container-search-bar">
                <i class="fa-regular fa-magnifying-glass"></i>
                <input v-model="params.valueSearch"/>
            </div>
            <div class="list-user" >
                <label class="user" v-for="(user,index) in getUserIdMatchingFilter" @click="">
                    <Checkbox :id="'selectUser'+user.id" :prefixId="user.id" :isChecked="selection.includes(user.id)" :isDisable="false" :add="addUser" :remove="removeUser"/>
                    <div class="picture">
                        <img 
                        :src="user.avatar ? user.avatar : 'img/avatar.jpg'"
                        @error="()=>imageUserOnError(user.id)"
                    />
                    </div>
                    <div class="info no-select">
                        <div class="name no-select">
                            <p>{{ user.firstname || user.lastname ? (`${user.firstname} ${user.lastname}`).trim() : user.email.split('@')[0]}}</p>
                            <div class="badge no-select">{{ user.admin == true ? $t('dash.select-users.admin') : user.role && user.role.length > 0 ? $t(`dash.settings.user.${user.role[0]}`) : $t("dash.settings.user.Editor") }}</div>
                        </div>
                        <p class="email no-select">{{ user.email }}</p>
                    </div>
                </label>
            </div>

            <div class="form-custom" v-if="formCustom">
                <div class="item" v-for="item in formCustom" v-if="typeof item.show == 'function' ? item.show(selection) : !!item.show">
                    <Checkbox v-if="item.type == 'checkbox'" :id="item.name" :prefixId="''" :isChecked="item.value" :isDisable="false" :add="(name)=>{changeValueForm(name,true)}" :remove="(name)=>{changeValueForm(name,false)}"/>
                    <label :for="item.name" class="title no-select">{{ item.label }}</label>
                </div>
            </div>
          
            <div class="btns">
                <div class="btn-primary" @click="validSelection">{{ textButtonValid}}</div>
                <div class="btn-secondary" @click="cancel">{{ $t('dash.button.cancel') }}</div>
                
            </div>
        </div>
    </div>
</template>

<script>

import store from './../../../store';
import Checkbox from '../utils/checkbox.vue'
import { EventBus } from '@/event-bus';

const paramsDefault = {
    valueSearch: '',
    sortBy: 'firstname',
    defaultSelection : [],
    subTitle: '',
    validButtonText: null
}

export default {
    components: {
        Checkbox,
    },

    data() {
        return {
            isActive: false,
            cbValidate: null,
            cbCanceled: null,
            params: paramsDefault,
            users:[],
            selection: [],
            formCustom: null,
        }
    },

    mounted(){
        EventBus.$on('selectUsers', this.startSelectUsers);
    },


    methods: {
        // cb(users[], isCancled)
        startSelectUsers(cbValidate = null, params = {}, cbCanceled = null) {
            this.isActive = true
            this.cbValidate = cbValidate
            this.cbCanceled = cbCanceled
            this.params = {...paramsDefault,...params}
            this.users = structuredClone(params.users || this.$store.getters['users/getUsers']);
            this.selection = this.params.defaultSelection.filter(id => this.users[id])
            delete this.users[this.$store.getters['users/getCurrentUser'].id]
            this.formCustom = params.formCustom || null
            
        },
        validSelection() {
            this.isActive = false
            if(this.cbValidate) this.cbValidate([...this.selection], this.formCustom)
        },
        cancel() {
            this.isActive = false
            if(this.cbCanceled) this.cbCanceled([...this.selection])
        },

        addUser(checkboxId) {
            const userId = checkboxId.slice(10)
            this.selection = [...this.selection,userId]
        },

        removeUser(checkboxId) {
            const userId = checkboxId.slice(10)
            this.selection = this.selection.filter((id) => id !== userId)
        },

        imageUserOnError(userId) {
            console.log('imageUserOnError',userId)
            this.$set(this.users[userId], "avatar", 'img/avatar.jpg')
        },

        changeValueForm(name, value) {
            const index = this.formCustom.findIndex(item => item.name == name)

            if(index != -1) {
                this.$set(this.formCustom[index], "value", value)
            } else {
                console.error('changeValueForm: item not found', name)
            }
        }

    },

    computed: {

        getUsersBySort() {
            // [...new Set([...this.params.defaultSelection,...Object.values(this.users)])]
            // permet de mettre en premiere position les comptes selctionnés par default quoi qu'il advienne
            return [...new Set([
                ...this.params.defaultSelection,
                ...Object.keys(this.users).sort((userId1, userId2) => {
          
                    let val1,val2;
                    if(this.params.sortBy == 'role'){
                        val1 = this.users[userId1].admin == true ? 'administrateur' : !this.users[userId1].role || this.users[userId1].role.length == 0 ? 'editeur' : this.users[userId1].role[0].toLowerCase()
                        val2 = this.users[userId2].admin == true ? 'administrateur' : !this.users[userId2].role || this.users[userId2].role.length == 0 ? 'editeur' : this.users[userId2].role[0].toLowerCase()
                    }else{
                        val1 = this.users[userId1][this.params.sortBy].toLowerCase(); // Convertir en minuscules pour un tri insensible à la casse
                        val2 = this.users[userId2][this.params.sortBy].toLowerCase();
                    }      

                    if (val1 < val2) {
                        return -1;
                    } else if (val1 > val2) {
                        return 1;
                    } else {
                        return 0;
                    }
             
                })
            ])]
        },

        getUserIdMatchingFilter() {           
            return this.getUsersBySort.filter((userId) => (
                this.users[userId] && (
                    this.params.valueSearch.trim() == '' ||
                    this.users[userId].email && this.users[userId].email.trim().toLowerCase().indexOf(this.params.valueSearch.trim().toLowerCase()) >= 0 ||
                    this.users[userId].lastname.trim().toLowerCase().indexOf(this.params.valueSearch.trim().toLowerCase()) >= 0 || 
                    this.users[userId].firstname.trim().toLowerCase().indexOf(this.params.valueSearch.trim().toLowerCase()) >= 0
                )
            )).map((userId)=>this.users[userId])
        },

        textButtonValid() {
            if (typeof this.params.validButtonText === 'function') {
                return this.params.validButtonText(this.selection, this.users, this.formCustom)
            } else {
                return this.params.validButtonText || this.$t('dash.select-users.assign')
            }
        }
        
    },

    beforeDestroy() {
        EventBus.$off('selectUsers', this.startSelectUsers);
    },


}
</script>

<style lang="scss" scoped>

</style>